import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import doRecoverPassword from "Redux/Actions/RecoverPasswordAction";

import * as ROUTES from "Constants/Routes";
import AppConstants from "Constants/AppConstants";
import MODALMESSAGES from "Constants/Messages";
import STRINGS from "Constants/Strings";
import { HTTP_STATUS } from "Communication/Constants";
import "./VerificationCode.scss";
import { updateProductToVault } from "Components/MarketPlace/Action/MarketPlaceAction";
import doRegistration from "../Register/Actions/RegisterAction";
import VerificationCode from "./VerificationCode";
import { doForgotPassword } from "../Signin/Actions/SigninAction";
import doVerificationCodeAction from "./Actions/VerificationCodeAction";
import { confirmApplicantCreate } from "Components/JointApplicant/Actions/JointApplicantAction";
import {
  setInSessionJointApplicant,
  fillApplicationSlot,
  inviteApplicationSlot,
  otpVerifyInvite,
} from "../JointApplicant/Actions/JointApplicantAction";

class VerificationCodeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalType: "",
      modal: {
        title: "",
        description: "",
      },
      steps: [],
      activeStepID: 4, // 4th for Joint applicants
    };
  }

  componentDidMount() {
    const {
      signinState,
      history,
      registerState,
      otpVerify,
      inSessionJointApplicant,
    } = this.props;
    if (
      !signinState.username &&
      !Object.keys(registerState.success).length &&
      !otpVerify.success
    ) {
      if (!inSessionJointApplicant) {
        history.push(ROUTES.SIGN_IN);
      }
    }
    if (inSessionJointApplicant) {
      let steps = [];
      let index = 1;
      AppConstants.JOINT_APPLICANT.FLOW.forEach((flow) => {
        steps.push({
          Id: index,
          Name: STRINGS.STEPS[flow.componentName],
        });
        index += 1;
      });
      this.setState({
        steps,
      });
    }
  }

  componentDidUpdate(prevProps) {
    console.log("componentDidUpdate");
    const {
      verificationCodeState,
      recoverPasswordState,
      history,
      forgotPasswordState,
      doUpdateProductToVault,
      vaultProductList,
    } = this.props;

    if (
      verificationCodeState !== prevProps.verificationCodeState ||
      recoverPasswordState !== prevProps.recoverPasswordState
    ) {
      if (vaultProductList.length !== 0) {
        doUpdateProductToVault(vaultProductList);
      }
      if (verificationCodeState.success.status === HTTP_STATUS.OK) {
        if (verificationCodeState.success?.data?.data) {
          const {
            slotId,
            applicationId,
          } = verificationCodeState.success.data.data;
          if (slotId && slotId !== "") {
            sessionStorage.setItem(
              STRINGS.JOIN_APPLICANT.JOINT_APPLICANT_SLOTID,
              slotId + "-register"
            );
            sessionStorage.setItem(
              STRINGS.JOIN_APPLICANT.JOINT_APPLICANT_APPLICATION_ID,
              applicationId
            );
            history.push(ROUTES.VAULT_PASSWORD);
          } else {
            history.push(ROUTES.VAULT_PASSWORD);
          }
        } else {
          history.push(ROUTES.VAULT_PASSWORD);
        }
      } else if (recoverPasswordState.success.status === HTTP_STATUS.OK) {
        history.push(ROUTES.SIGNIN_FORGOT_VERIFICATION_VAULT_PASSWORD);
      }
    }
    if (prevProps.forgotPasswordState !== forgotPasswordState) {
      if (
        forgotPasswordState.success &&
        forgotPasswordState.success.status === HTTP_STATUS.OK
      ) {
        if (
          forgotPasswordState.success.data.otpTo ===
          STRINGS.FORGOTPASSWORD.OTP_TO.EMAIL
        ) {
          this.setModalState({
            showModal: true,
            modalType: AppConstants.MODALTYPE.SUCCESS,
            modal: {
              title: STRINGS.FORGOTPASSWORD.MODAL.SUCCESS_MAIL,
              description: "",
            },
          });
        } else {
          this.setModalState({
            showModal: true,
            modalType: AppConstants.MODALTYPE.SUCCESS,
            modal: {
              title: STRINGS.FORGOTPASSWORD.MODAL.SUCCESS_MESSAGE,
              description: "",
            },
          });
        }
      }
    }
  }

  setModalState = (modal) => {
    this.setState(modal);
  };

  handleBack = () => {
    const { history, forgotPasswordState, registerState } = this.props;
    if (
      forgotPasswordState.success &&
      forgotPasswordState.success.status === HTTP_STATUS.OK
    ) {
      history.push(ROUTES.FORGOT_PASSWORD);
    } else if (registerState) {
      history.push(ROUTES.REGISTER);
    }
  };

  toggleModal = () => {
    const { showModal } = this.state;
    this.setState({
      showModal: !showModal,
    });
  };

  handlVerificationCodeSubmit = (userDetail) => {
    const {
      registerState,
      doVerificationCode,
      doGetRecoverPassword,
      otpVerify,
      inSessionJointApplicant,
      doConfirmApplicantCreate,
      doSetInSessionJointApplicant,
      doFillApplicationSlot,
      history,
      applicationId,
    } = this.props;
    console.log("handlVerificationCodeSubmit", userDetail);
    if (inSessionJointApplicant) {
      doConfirmApplicantCreate(
        { otpId: userDetail.otpId, otp: userDetail.otp },
        (res) => {
          const jointInfo = {
            ...inSessionJointApplicant,
            applicantId: res.data.applicantId,
          };
          doSetInSessionJointApplicant(jointInfo);
          history.push(ROUTES.EMPLOYMENT_AND_INCOME);
          // doFillApplicationSlot(
          //     {
          //       applicantId: jointInfo.applicantId,
          //       slotId: inSessionJointApplicant.id,
          //       applicationId,
          //     },
          //     () => {
          //
          //     });
        }
      );
    } else {
      if (registerState.success || otpVerify.success) {
        doVerificationCode(userDetail);
      } else {
        doGetRecoverPassword(userDetail);
      }
    }
  };

  handleSendVerificationCode = () => {
    const {
      registerState,
      doRegistratioProcess,
      signinState,
      doForgotPasswordRequest,
      otpVerify,
      doOtpVerifyInvite,
      otp,
    } = this.props;
    if (otpVerify.success) {
      doOtpVerifyInvite(
        {
          purpose: "register",
          otpId: otp.otpId,
          otp: otp.otp,
        },
        (otpVerifyRes) => {
          if (otpVerifyRes.status === HTTP_STATUS.OK) {
            this.setState({
              showModal: true,
              modalType: AppConstants.MODALTYPE.SUCCESS,
              modal: {
                title: MODALMESSAGES.VERIFICATIONCODE.SUCCESSMSG,
                description: "",
              },
            });
          }
        }
      );
    } else {
      if (registerState.success !== "") {
        const userDetail = JSON.parse(registerState.success.config.data);

        const userDetails = {
          email: userDetail.email,
          msisdn: userDetail.msisdn,
          otpTo: userDetail.otpTo,
        };
        doRegistratioProcess(userDetails);

        if (registerState.success.status === HTTP_STATUS.OK) {
          const Successmsg = `${MODALMESSAGES.VERIFICATIONCODE.SUCCESSMSG}. `;
          this.setState({
            showModal: true,
            modalType: AppConstants.MODALTYPE.SUCCESS,
            modal: {
              title: Successmsg,
              description: "",
            },
          });
        } else {
          this.setState({
            showModal: true,
            modalType: AppConstants.MODALTYPE.FAILURE,
            modal: {
              title: MODALMESSAGES.VERIFICATIONCODE.ERRORMSG,
              description: "",
            },
          });
        }
      } else if (signinState.username !== "") {
        const userDetails = {
          credential: signinState.username,
        };
        doForgotPasswordRequest(userDetails);
      } else {
        this.setState({
          showModal: true,
          modalType: AppConstants.MODALTYPE.FAILURE,
          modal: {
            title: MODALMESSAGES.VERIFICATIONCODE.RESENDCODEERROR,
            description: "",
          },
        });
      }
    }
  };

  render() {
    const { showModal, modalType, modal, steps, activeStepID } = this.state;
    const {
      registerState,
      forgotPasswordState,
      otpVerify,
      inSessionJointApplicant,
    } = this.props;
    return (
      <>
        <VerificationCode
          handlVerificationCodeSubmit={this.handlVerificationCodeSubmit}
          handleSendVerificationCode={this.handleSendVerificationCode}
          showModal={showModal}
          modalType={modalType}
          modal={modal}
          registerState={registerState}
          otpVerify={otpVerify}
          forgotPasswordState={forgotPasswordState}
          handleBack={this.handleBack}
          inSessionJointApplicant={inSessionJointApplicant}
          steps={steps}
          activeStepID={activeStepID}
        />
      </>
    );
  }
}

VerificationCodeContainer.propTypes = {
  verificationCodeState: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  recoverPasswordState: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  registerState: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  forgotPasswordState: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  history: PropTypes.oneOfType([PropTypes.object]),
  push: PropTypes.func,
  doVerificationCode: PropTypes.func,
  doGetRecoverPassword: PropTypes.func,
  doRegistratioProcess: PropTypes.func,
  doForgotPasswordRequest: PropTypes.func,
  signinState: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  doUpdateProductToVault: PropTypes.func,
  vaultProductList: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.string,
  ]).isRequired,
  otpVerify: PropTypes.oneOfType([PropTypes.object]),
  otp: PropTypes.object,
  doConfirmApplicantCreate: PropTypes.func.isRequired,
  inSessionJointApplicant: PropTypes.object,
  applicationId: PropTypes.string,
  doinviteApplicationSlot: PropTypes.func.isRequired,
};
VerificationCodeContainer.defaultProps = {
  verificationCodeState: "",
  recoverPasswordState: "",
  registerState: "",
  forgotPasswordState: "",
  signinState: "",
  otpVerify: "",
  history: () => {},
  push: () => {},
  doVerificationCode: () => {},
  doGetRecoverPassword: () => {},
  doRegistratioProcess: () => {},
  doForgotPasswordRequest: () => {},
  doUpdateProductToVault: () => {},
  otp: null,
};

const mapDispatchToProps = (dispatch) => {
  return {
    doRegistratioProcess: (userDetails) =>
      dispatch(doRegistration(userDetails)),
    doVerificationCode: (userDetails) =>
      dispatch(doVerificationCodeAction(userDetails)),
    doGetRecoverPassword: (userDetails) =>
      dispatch(doRecoverPassword(userDetails)),
    doForgotPasswordRequest: (userDetails) =>
      dispatch(doForgotPassword(userDetails)),
    doUpdateProductToVault: (productList) =>
      dispatch(updateProductToVault(productList)),
    doConfirmApplicantCreate: (productList, callback) =>
      dispatch(confirmApplicantCreate(productList, callback)),
    doSetInSessionJointApplicant: (request, callback) =>
      dispatch(setInSessionJointApplicant(request, callback)),
    doFillApplicationSlot: (request, callback) =>
      dispatch(fillApplicationSlot(request, callback)),
    doinviteApplicationSlot: (request, callback) =>
      dispatch(inviteApplicationSlot(request, callback)),
    doOtpVerifyInvite: (request, callback) =>
      dispatch(otpVerifyInvite(request, callback)),
  };
};
const mapStateToProps = (state) => ({
  registerState: state.RegisterReducer,
  recoverPasswordState: state.RecoverPasswordReducer,
  verificationCodeState: state.VerificationCodeReducer,
  forgotPasswordState: state.ForgotPasswordReducer,
  signinState: state.SigninReducer,
  vaultProductList: state.VaultReducer.vaultProductList,
  otpVerify: state.JoinApplicantReducer.otpVerify,
  otp: state.JoinApplicantReducer.otp,
  inSessionJointApplicant: state.JoinApplicantReducer.inSessionJointApplicant,
  applicationId: state.JoinApplicantReducer.applicationId,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerificationCodeContainer);
